// extracted by mini-css-extract-plugin
module.exports = {"key-metrics-container":"KeyMetrics_key-metrics-container__285vJ","key-metrics-title":"KeyMetrics_key-metrics-title__gK2n9"};